module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "alerter"
  }, [_c('transition', {
    attrs: {
      "name": "pop"
    }
  }, [(_vm.isVisible) ? _c('div', {
    staticClass: "alerter__wrap overlay",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getAttention($event)
      }
    }
  }, [_c('div', {
    staticClass: "alerter__dialog",
    class: {
      attention: _vm.needsAttention
    }
  }, [_c('div', {
    staticClass: "alerter__content"
  }, [_vm._t("default", [(_vm.title) ? _c('h2', {
    staticClass: "alerter__first-child"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), (_vm.message) ? _c('p', {
    class: _vm.title ? '' : 'alerter__first-child'
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])], 2), _c('div', {
    staticClass: "alerter__actions"
  }, _vm._l((_vm.actions), function(action) {
    return _c(action.primary ? 'primary-button' : 'a', {
      key: action.name,
      tag: "component",
      class: {
        'tag': !action.primary, 'button-timid': !action.primary, 'button-timid--warning': action.danger
      },
      attrs: {
        "href": "#"
      },
      on: {
        "clicked": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.fire(action)
        },
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.fire(action)
        }
      }
    }, [_vm._v(_vm._s(action.name))])
  }))])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4deee43c","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Alerter.vue
// module id = vW+O
// module chunks = 0 1